import { tokenHelper } from "../stores/helpers";
import { hasActiveSubscription, REPORT_MENU_ITEMS } from "./planLimits";
import { useUsageStore } from "../stores/Usage";
import { useAuth } from "../stores/Auth/Auth";

const REPORT_FEATURES = REPORT_MENU_ITEMS.map((item) => item.permission);

const getEffectivePermissions = async () => {
  const sessionPermissions = (await tokenHelper.getPermissions()) || {};
  const livePermissions = useUsageStore.getState().permissions;
  return livePermissions ?? sessionPermissions;
};

const getPermissionLevel = async (feature, permissions, isRoot) => {
  if (isRoot) return 2;
  return Number(permissions[feature] ?? 0);
};

const getActiveSubscription = (user) => {
  const live = useUsageStore.getState().hasActiveSubscription;
  if (live === true || live === false) return live === true;
  return hasActiveSubscription(user);
};

const canAccessReport = (isRoot, permissions, feature, activeSubscription) => {
  if (isRoot) return true;
  // Temporarily disable active subscription gating for report pages.
  // if (!activeSubscription) return false;
  return Number(permissions?.[feature] ?? 0) >= 1;
};

// Check if user can view a feature (level >= 1)
export const canView = async (feature) => {
  if (feature === "dashboard" || feature === "subscription_plans" || feature === "subscription_success") {
    return true;
  }

  const user = await tokenHelper.getUser();
  const authUser = useAuth.getState().user;
  const isRoot = (user?.role ?? authUser?.role) === "ROOT";
  if (isRoot) return true;

  const permissions = await getEffectivePermissions();
  const activeSubscription = getActiveSubscription(user ?? authUser);

  if (REPORT_FEATURES.includes(feature)) {
    return canAccessReport(isRoot, permissions, feature, activeSubscription);
  }

  return (await getPermissionLevel(feature, permissions, isRoot)) >= 1;
};

// Check if user can edit a feature (level >= 2)
export const canEdit = async (feature) => {
  const user = await tokenHelper.getUser();
  const authUser = useAuth.getState().user;
  const isRoot = (user?.role ?? authUser?.role) === "ROOT";
  const permissions = await getEffectivePermissions();
  return (await getPermissionLevel(feature, permissions, isRoot)) >= 2;
};

// Check if user has a specific level
export const hasPermissionLevel = async (feature, level) => {
  const user = await tokenHelper.getUser();
  const authUser = useAuth.getState().user;
  const isRoot = (user?.role ?? authUser?.role) === "ROOT";
  const permissions = await getEffectivePermissions();
  return (await getPermissionLevel(feature, permissions, isRoot)) >= level;
};
